module.exports = __webpack_public_path__ + "static/img/banner-score.4464298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/banner-score.png
// module id = yM72
// module chunks = 96